// Keep the backend copy identical (verified by the catalog tests).
const catalog = require('../config/gestaoCatalog.json')
const MARKER = 'gestao_permissoes_granulares_v1'
const isAdmin = permissions => permissions.includes('administrador') || permissions.includes('super_administrador')
function allowed(permissions, item) {
  if (!item) return false
  if (isAdmin(permissions)) return true
  if (permissions.includes(MARKER)) return permissions.includes(item.permission)
  if (item.key === 'fechamento-diario' && permissions.includes('emitir_fechamento_diario')) return true
  return item.legacy.every(p => permissions.includes(p))
}
function findReport(key) {
  if (key === 'despesas-analise-por-refil') key = 'analise-por-refil'
  return catalog.find(item => item.kind === 'relatorio' && item.key === key)
}
// Pure conversion: no database access. Snapshot the original array for reversal.
function convert(permissions) {
  if (permissions.includes(MARKER)) return [...permissions]
  const individual = new Set(catalog.map(item => item.permission).filter(p => p !== 'emitir_fechamento_diario'))
  return [...new Set([...permissions.filter(p => !individual.has(p)), MARKER,
    ...catalog.filter(item => allowed(permissions, item)).map(item => item.permission)])]
}
module.exports = { catalog, MARKER, isAdmin, allowed, findReport, convert }
